<template>
  <div class="product product-customization">
    <div class="a product-style-2 equal-elem product-box-size" :class="{ selecionado: product.selecionado }">
      <div>
        <div class="product-thumnail align-center">
          <figure class="product-box-image">
            <img async :src="product.img" :alt="product.name" class="product-image-size" />
          </figure>
          <span v-for="(selo, index) in product.productSelos" :key="index">
            <img
              async
              :srcset="selo.Selo"
              :src="selo.Selo"
              :alt="selo.Campanha"
              :title="selo.Campanha"
              class="img-slide"
              v-bind:style="
                selo.Position == 'botton'
                  ? 'position:absolute;left:10px;max-width:50px;bottom:0;'
                  : 'position:absolute;left:10px;max-width:50px;top:20px;bottom:0;'
              "
            />
          </span>
        </div>
        <div class="product-info row align-center">
          <div class="">
            <span class="product-code" style="float: left">Código: {{ product.code }} </span>
          </div>

          <div class="">
            <h3>
              <div class="product-name">
                <span>{{ product.name }} ({{ product.code }})</span>
              </div>
            </h3>
          </div>
          <div class="product-potencia row align-center" v-if="product.gerador">
            <span class="product-potencia-label">Potência: {{ product.potenciaGerador }} </span>
            <span class="product-potencia-label">Inversor: {{ product.potenciaInversor }} </span>
            <span class="product-potencia-label"> {{ product.tensao }} {{ product.fase }} </span>
          </div>
          <div>
            <p class="product-description">{{ product.description }}</p>
          </div>

          <div class="wrap-price" style="height: 25px">
            <del v-if="product.isLogged && product.promotionalPrice > 0">
              <p class="product-price" style="color: red">De: {{ formatPrice(product.promotionalPrice) }}</p>
            </del>
            <br v-if="product.isLogged && product.promotionalPrice > 0" />
            <span v-if="!product.isLogged && product.price > 0" class="product-price" style="height: 25px">{{ formatPrice(product.price) }}</span>
            <span v-if="!product.isLogged && product.price == 0" class="product-price" style="height: 25px">Produto Indisponível</span>
            <span v-if="product.isLogged" style="color: #0066a1; height: 25px" class="product-price">{{ formatPrice(product.price) }}</span>
            <br />
            <span v-if="!product.isLogged" class="product-suggested-price tag tag-red">Preço sugerido ao consumidor final</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.product-name {
  height: 50px;
}
.product-potencia {
  display: block;
  margin-bottom: 10px !important;
  line-height: 25px;
}
.product-potencia-label {
  color: #007bff;
  background-color: #e0f2fe;
  padding: 2px;
  border-radius: 3px;
  font-weight: bold;
  margin-right: 2px;
  margin-bottom: 2px;
  font-size: 12px;
}
</style>

<script>
export default {
  name: 'Product',
  data() {
    return {
      precoComSt: 'Consultar valor com ST',
      disponibilidade: 'Consultar Disponibilidade',
      countDisponibilidade: 0,
      countPrecoComST: 0
    }
  },
  props: ['product', 'selecionar'],
  methods: {
    formatPrice: function (price) {
      if (price > 0) {
        return (
          'R$' +
          price.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        )
      } else {
        return 'Produto Indisponível'
      }
    },
    getDisponibilidade: function (event) {
      if (this.countDisponibilidade == 0) {
        let xhr = new XMLHttpRequest()

        xhr.open('POST', this.$apiUrl + 'Produto.svc/getsaldo')
        xhr.setRequestHeader('Content-type', 'application/json')
        xhr.withCredentials = true

        xhr.onload = () => {
          if (xhr.status == 200) {
            this.countDisponibilidade++
            let saldo = JSON.parse(xhr.responseText)

            if (saldo === 'DISPONÍVEL') {
              this.disponibilidade = ': Disponível em estoque'
              $(event.target).removeClass('btn-light btn btn-xs')
              $(event.target).addClass('product-available')
            } else if (saldo === 'INDISPONÍVEL') {
              this.disponibilidade = ': Indisponível em estoque'
              $(event.target).removeClass('btn-light btn btn-xs')
              $(event.target).addClass('product-unavaiable')
            } else if (saldo === 'SOB ENCOMENDA') {
              this.disponibilidade = ': Sob Encomenda'
              $(event.target).removeClass('btn-light btn btn-xs')
              $(event.target).addClass('product-unavaiable')
            } else {
              if (saldo.split(';')[1]) {
                this.disponibilidade =
                  ': Disponível em ' +
                  saldo.split(';')[0] +
                  '<br>' +
                  '(<strong>' +
                  saldo.split(';')[1].charAt(0).toUpperCase() +
                  saldo.split(';')[1].slice(1).toLowerCase() +
                  '</strong>)'
              } else {
                this.disponibilidade = ': Disponível em ' + saldo.split(';')[0]
              }

              $(event.target).removeClass('btn-light btn btn-xs')
              $(event.target).addClass('product-unavaiable')
            }

            $(event.target).css('font-size', '12px')
          }
        }

        xhr.send(
          JSON.stringify({
            codigoProduto: this.product.code.split('-')[0],
            prdQtdeUnidade: 1
          })
        )
      }
    }
  }
}
</script>
